import { inject, Injectable, Injector, TransferState } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest,
    HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { LocaleService } from '@finder/shared/services/locale-service/locale-service.service';
import { LOCALE, LOCALE_DEFAULT, SSR_LOCALE } from '@finder/shared/constants/app.constants';
import { ConfigService } from '@finder/core/config.service';
import { LoggerService } from '@wdpr/ra-angular-logger';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    private ssrLocale = inject(LOCALE, { optional: true });

    constructor(
        private injector: Injector,
        private transferState: TransferState,
    ) { }

    /**
     * Add the locale to every request
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const localeService = this.injector.get(LocaleService);
        const configService = this.injector.get(ConfigService);
        const loggerService = this.injector.get(LoggerService);
        // Get locale from cookie, and if it's not defined, use the default
        const locale = this.ssrLocale || localeService.getLocale() || LOCALE_DEFAULT;

        let headers: any = {
            setHeaders: {
                'Accept-Language': locale
            },
        };

        // @SSR: Store the locale if we have it
        if (this.ssrLocale) {
            this.transferState.set(SSR_LOCALE, this.ssrLocale);
            loggerService.warn(`!!! SSR WILL NOT CACHE THE REQUEST !!!`);
        }

        /**
         * @SSR:
         * We had to remove the `withCredentials` property from all interceptors because this
         * causes angular to NOT cache the request. This works fine in lowers/prod because
         * the cookies are sent across the same domain. For local dev this doesn't work so
         * we have to use the property FOR LOCAL DEV ONLY.
         */
        if (configService.isDevelopment()) {
            headers.withCredentials = true;
        }

        req = req.clone(headers);

        return next.handle(req);
    }
}
